import { homepageUrl } from "./runtimeConfig";

// Card links live on the website, not on the app, so they build the main domain.
export const getCardUrl = (cardId: string | undefined): string => {
  const frontPage = homepageUrl();
  if (!cardId) return "";

  return `${frontPage}/c/${cardId}`;
};

// The address in the card's QR code. src=qr lets the card count the visit as a scan.
export const getCardQrUrl = (cardId: string | undefined): string => {
  const cardUrl = getCardUrl(cardId);
  return cardUrl && `${cardUrl}?src=qr`;
};
